import React, { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert";

import {
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBBtn,
  MDBCard,
  MDBTextArea,
  MDBCardText,
  MDBCardHeader,
  MDBCardBody,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBInput,
} from "mdb-react-ui-kit";

import config from "../config.json";
import readXlsxFile from "read-excel-file";
import env from "react-dotenv";

import TitleWithImageCard from "../components/Cards/TitleWithImageCard";

function AdminPage({ setSidebarDiv, sidebarDiv }) {
  const [data, setData] = useState("");
  const [tableData, setTableData] = useState("");
  const [updateEmployeeFeedback, setUpdateEmployeeFeedback] = useState("");
  const [updateEntityFeedback, setUpdateEntityFeedback] = useState("");
  const [addBulkUsersFeedback, setAddBulkUsersFeedback] = useState("");
  const [employeeExcelFile, setEmployeeExcelFile] = useState();

  const [normalFile, setNormalFile] = useState(null);

  const input = document.getElementById("fileInput");
  const input2 = document.getElementById("fileInputNormal");

  const readExcelFile = (event) => {
    event.preventDefault();
    console.log("READING FILE");
    readXlsxFile(input.files[0]).then((rows) => {
      // `rows` is an array of rows
      // each row being an array of cells.
      setEmployeeExcelFile(rows);
      console.log(rows);
    });
  };

  const readNormalFile = (event) => {
    event.preventDefault();
    console.log(input2.files[0]);
    setNormalFile(input2.files[0]);
    SendFileToServer();
  };

  useEffect(() => {
    setTableData(dataTable);
  }, []);

  const dataTable = [
    { id: 1, fname: "Fname1", lname: "-", handle: "@id1" },
    { id: 2, fname: "Fname2", lname: "", handle: "@id2" },
    { id: 3, fname: "Fname3", lname: "Lname3.0", handle: "@id3" },
    { id: 4, fname: "Fname4", lname: "Lname4.0", handle: "@id4" },
  ];

  async function UpdateAllEmployees() {
    const response = await fetch(
      config.domainName + ":" + config.port + "/api/employeequery",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          function: "UpdateEmployeeGrades",
        }),
      }
    );

    const content = await response.json();

    setUpdateEmployeeFeedback(content);
    setTimeout(() => {
      setUpdateEmployeeFeedback("");
    }, 5000);
    //console.log(content);
  }

  async function UpdateAllEntities() {
    const response = await fetch(
      config.domainName + ":" + config.port + "/api/entityquery",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          function: "UpdateEntityScores",
        }),
      }
    );

    const content = await response.json();
    setUpdateEntityFeedback(content);
    setTimeout(() => {
      setUpdateEntityFeedback("");
    }, 5000);
    //console.log(content);
  }

  async function GetAllTestsiMocha() {
    const response = await fetch(config.imocha_base_url + "/v3/tests", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": env.IMOCHA_API_KEY,
      },
    });

    const content = await response.json();

    console.log(content);
  }

  async function BulkRegisterEmployees() {
    //console.log(JSON.stringify(data));
    if (data !== "") {
      const response = await fetch(
        config.domainName + ":" + config.port + "/api/BulkRegister",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data,
          }),
        }
      );

      const content = await response.json();

      setAddBulkUsersFeedback(
        content["Number added"] + " " + content["Message"]
      );
      setTimeout(() => {
        setAddBulkUsersFeedback("");
      }, 5000);
    } else {
      setAddBulkUsersFeedback("Empty Input");
      setTimeout(() => {
        setAddBulkUsersFeedback("");
      }, 4000);
    }
    //console.log(content);
  }

  async function SendFileToServer() {
    const data = new FormData();
    if (normalFile !== null) {
      data.append("file", normalFile);
      const response = await fetch(
        config.domainName + ":" + config.port + "/upload/certificate",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: data,
          }),
        }
      );

      const content = await response.json();
      console.log(content);
    }
  }

  const handleOnExport = () => {
    console.log("Pending function to Export table to sql format");
    // var sqlData = "INSERT INTO entities VALUES";
    // var loopData = "";
    // var blankString = "";

    // {
    //   dataTable.map((row) => {
    //     Object.keys(row).map(
    //       (c, i) => (loopData = blankString.concat(loopData, "'", row[c], "',"))
    //     ),
    //       (loopData = blankString.concat(loopData, "\n"));
    //   });
    // }
    // console.log(loopData);

    // for (var i = 0; i < tableData.length; i++) {
    //   console.log(tableData[i]);
    //   console.log(Object.keys(tableData[i]).length);
    //   // loopData = blankString.concat(loopData, "(");

    //   for (var j = 0; j < Object.keys(tableData[i]).length; j++) {
    //     {
    //       dataTable.map((row) =>
    //         Object.keys(tableData[i]).map(
    //           (c, i) =>
    //             (loopData = blankString.concat(
    //               loopData,
    //               "'",
    //               tableData[i][c],
    //               "',"
    //             ))
    //         )
    //       );
    //     }

    //     // Object.keys(tableData[i]).map(
    //     //   (c, i) =>
    //     //     (loopData = blankString.concat(
    //     //       loopData,
    //     //       "'",
    //     //       tableData[i][c],
    //     //       "',"
    //     //     ))
    //     // );
    //     loopData = blankString.concat(loopData, "\n");
    //     console.log(loopData);
    //   }
    //   // loopData = blankString.concat(
    //   //   loopData,
    //   //   blankString,
    //   //   "\n",
    //   //   "('",

    //   //   tableData[i]["id"],
    //   //   "','",
    //   //   tableData[i]["fname"].toString().trim(),
    //   //   "','",
    //   //   tableData[i]["lname"],
    //   //   "','",
    //   //   tableData[i]["handle"],
    //   //   "')"
    //   // );
    // }

    // sqlData = blankString.concat(sqlData, loopData);
    // console.log(sqlData);

    // var wb = utils.book_new(),
    //   ws = utils.json_to_sheet(tableData);
    // utils.book_append_sheet(wb, ws, "Data Sheet");
    // writeFile(wb, "ExcelTest.xlsx");
  };

  return (
    <div
      id="mainDiv"
      className="bg-image"
      style={{
        background:
          "linear-gradient(45deg, rgba(17, 17, 53, 1), rgba(5, 80, 240, 1))",
      }}
    >
      <MDBContainer className="p-5 my-5">
        <MDBRow className="row-cols-1 row-col-md-12 g-4 d-flex justify-content-center">
          <MDBCol id="title">
            <TitleWithImageCard
              title={"Admin Page"}
              img={"/mainLogos/elguards-logo-blue.png"}
            />
          </MDBCol>

          <MDBCol id="databaseUpdate" className="w-100">
            <MDBCard alignment="center">
              <MDBCardHeader alignment="left">
                <h2>Update Records</h2>
              </MDBCardHeader>
              <MDBRow>
                <MDBCol className="p-5">
                  <MDBBtn className="p-4 m-4 w-50" onClick={UpdateAllEmployees}>
                    Update All Employees
                  </MDBBtn>
                  {updateEmployeeFeedback !== "" && (
                    <Alert>{updateEmployeeFeedback}</Alert>
                  )}
                  <MDBBtn className="p-4 m-4 w-50" onClick={UpdateAllEntities}>
                    Update All Entites
                  </MDBBtn>
                  {updateEntityFeedback !== "" && (
                    <Alert>{updateEntityFeedback}</Alert>
                  )}

                  <MDBBtn className="p-4 m-4 w-50" onClick={GetAllTestsiMocha}>
                    GET ALL TESTS
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            </MDBCard>
          </MDBCol>
          <MDBCol id="bulkUsers" className="w-100">
            <MDBCard alignment="center">
              <MDBCardHeader alignment="left">
                <h2>Add Bulk Users</h2>
              </MDBCardHeader>
              <MDBContainer className="px-5 py-2">
                <MDBCardText>Enter User IDs</MDBCardText>
                <MDBCardText>You must follow the following format</MDBCardText>
                <MDBCardText>usertype-username-password</MDBCardText>
                <MDBTextArea
                  label="User Data"
                  id="textAreaExample"
                  placeholder="0-test-123"
                  rows={5}
                  onChange={(e) => {
                    setData(e.target.value);
                  }}
                />
                {addBulkUsersFeedback !== "" && (
                  <Alert>{addBulkUsersFeedback}</Alert>
                )}
                <MDBBtn
                  className="p-4 m-4 w-50"
                  onClick={BulkRegisterEmployees}
                >
                  Submit Bulk User Data
                </MDBBtn>
              </MDBContainer>
            </MDBCard>
          </MDBCol>
          <MDBCol id="tableExport" className="w-100">
            <MDBCard alignment="center">
              <MDBCardHeader>
                <h2>Table Export</h2>
                <h5>
                  Experimental Feature. Does not have any functionality
                  currently
                </h5>
              </MDBCardHeader>
              <MDBCardBody>
                <MDBBtn className="p-4 m-4 w-50" onClick={handleOnExport}>
                  Export Table
                </MDBBtn>
                <MDBTable>
                  <MDBTableHead>
                    <tr>
                      {Object.keys(dataTable[0]).map((e) => (
                        <th key={e}>{e}</th>
                      ))}
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                    {dataTable.map((row) => (
                      <tr scope="row" key={row.id}>
                        {Object.keys(row).map((c, i) => (
                          <td key={c.id + "_" + i}>{row[c]}</td>
                        ))}
                      </tr>
                    ))}
                  </MDBTableBody>
                </MDBTable>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol id="fileInput" className="w-100 ">
            <MDBCard alignment="center">
              <MDBCardHeader>
                <h2>Excel File Input</h2>
                <h5>
                  Experimental Feature. Does not have any functionality
                  currently
                </h5>
              </MDBCardHeader>

              <MDBRow className="p-5">
                <form
                  id="employeeTable"
                  //   onSubmit={submit}
                  onSubmit={readExcelFile}
                >
                  <MDBInput id="fileInput" type="file" />
                  <MDBBtn type="submit" className="p-4 m-4 w-50">
                    Submit File
                  </MDBBtn>
                  {employeeExcelFile && (
                    <>
                      <MDBBtn className="p-4 m-4 w-50">
                        Send changes to database
                      </MDBBtn>
                      <MDBTable>
                        <MDBTableHead>
                          <tr>
                            {employeeExcelFile[0].map((e) => (
                              <th key={e}>{e}</th>
                            ))}
                            <th key={"action"}>Actions</th>
                          </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                          {employeeExcelFile.map((row) => (
                            <tr scope="row" key={row.id}>
                              {Object.keys(row).map((c, i) => (
                                <td key={c.id + "_" + i}>{row[c]}</td>
                              ))}
                              <td key={row.id + "_button"}>
                                <MDBBtn>Edit</MDBBtn>
                              </td>
                            </tr>
                          ))}
                        </MDBTableBody>
                      </MDBTable>
                    </>
                  )}
                </form>
              </MDBRow>
            </MDBCard>
          </MDBCol>
          <MDBCol id="testInput" className="w-100 ">
            <MDBCard alignment="center">
              <MDBCardHeader>
                <h2>Normal File Input</h2>
                <h5>
                  Experimental Feature. Does not have any functionality
                  currently
                </h5>
              </MDBCardHeader>

              <MDBRow className="p-5">
                <form
                  id="employeeTable"
                  //   onSubmit={submit}
                  onSubmit={readNormalFile}
                >
                  <MDBInput id="fileInputNormal" type="file" />
                  <MDBBtn type="submit" className="p-4 m-4 w-50">
                    Submit File
                  </MDBBtn>
                </form>
              </MDBRow>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
}
export default AdminPage;
